import { matchPath } from 'react-router-dom';

export const matchPathWithRoutes = (path: string, routes: string[]) => {
  return routes.some((route) => {
    return matchPath({ path: route, end: true }, path) != null;
  });
};
